import dynamic from 'next/dynamic';

export function noSSR<T extends React.ComponentType<any>>(Component: T) {
  return dynamic(() => Promise.resolve(Component), {ssr: false}) as T;
}
